import { isRejectedWithValue } from '@reduxjs/toolkit';
import { notification } from '@/lib/notifications';
import { processServerError } from './listQuery';

// Failed calls show the server's message once, here; opt out with `handledError`.
export const notifyApiErrors = () => (next) => (action) => {
  if (isRejectedWithValue(action) && !action.payload?.handled) {
    // Endpoints with transformErrorResponse already carry `message`; the rest are raw.
    const payload = action.payload;
    notification.error(payload?.message ?? processServerError(payload).message);
  }
  return next(action);
};
